export default function normalizeBoolean(value: any): boolean | null {
    if (value) {
        return !!value
    }

    return null
}